import AnalyticsSingleton from 'modules/analytics';

const useAnalytics = () => ({
    analytics: AnalyticsSingleton,
});

export default useAnalytics;
